/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export * from "./ITeamSettingsDataService";
export * from "./TeamSettingsDataService";
